import Link from 'next/link';
import { toSpecialFixed } from '@/lib/misc/utils';
import usePortfolioBalance from '@/hooks/portfolio/usePortfolioBalance';
export default function UserBalances() {
  const {
    data: assetData
  } = usePortfolioBalance({});
  const totalBalance = () => {
    let totalUsd = 0;
    if (assetData && assetData?.balances.length) {
      assetData.balances.map(token => {
        if (token?.usd_value) totalUsd += token.usd_value;
      });
    }
    return totalUsd;
  };
  return <Link href='/portfolio' className='w-full' data-sentry-element="Link" data-sentry-component="UserBalances" data-sentry-source-file="UserBalances.tsx">
      <div className='genius-shadow items-center bg-genius-indigo rounded-[20px] border-genius-blue hover:bg-genius-blue transition-colors border-[1px] overflow-hidden h-fit flex items-center'>
        <div>
          <div className='p-3 pb-0 flex items-center justify-between'>
            <p className='text-[20px]'>Balances</p>
            <div className='flex items-center justify-center'>
              <div></div>
            </div>
          </div>
          <div className='pb-2'>
            <>
              <div className='px-3'>
                <p className='text-[32px]'>${toSpecialFixed(totalBalance(), 2).value}</p>
              </div>
            </>
          </div>
        </div>
      </div>
    </Link>;
}